module.exports = __webpack_public_path__ + "81e8a10d173ed7c858204f9b84629f01.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/double-note-poster.png
// module id = 1635
// module chunks = 0